import React, { useEffect } from 'react';
import { Tabs, message } from 'antd';
import { ACL } from 'components/common';
import ContractMessage from './ContractMessage';
import ClientTab from './ClientTab';

export default function Dashboard() {
	useEffect(() => {
		// Check for location permission state from localStorage
		const locationPermissionState = localStorage.getItem('locationPermissionState');

		if (locationPermissionState === 'denied') {
			message.warning(
				'Location permission is denied. Some features may not work properly. Please enable location access in your browser settings for the best experience.',
				8 // Show for 8 seconds to ensure user sees it
			);
			// Clear the state after showing the message
			localStorage.removeItem('locationPermissionState');
		} else if (locationPermissionState === 'timeout') {
			message.info(
				'Location permission check timed out. Some features may not work properly if location access is not enabled.',
				6 // Show for 6 seconds
			);
			// Clear the state after showing the message
			localStorage.removeItem('locationPermissionState');
		}
	}, []); // Run only once when component mounts

	return (
		<div>
			<ACL action="search" module="client_contract">
				<ContractMessage contractType="client" />
			</ACL>
			<ACL action="search" module="vendor_contract">
				<ContractMessage contractType="vendor" />
			</ACL>
			<Tabs
				defaultActiveKey="1"
				type="card"
				size="large"
				items={[
					{
						label: 'Client',
						key: '1',
						children: <ClientTab />,
					},
				]}
			/>
		</div>
	);
}
